import { createContext, useContext, useState } from 'react';

const ChatToggleContext = createContext(null);

export const ChatToggleProvider = ({ children }) => {
    const [isChatOpen, setIsChatOpen] = useState(false);
    return (
        <ChatToggleContext.Provider value={{ isChatOpen, setIsChatOpen }}>
            {children}
        </ChatToggleContext.Provider>
    );
};

export const useChatToggle = () => useContext(ChatToggleContext);

export default ChatToggleContext;
